import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'
import { ReactComponent as Icon } from "../svgs/F_Settings_Cog.svg"

const FSettingsCog: React.VFC<SvgIconProps> = props => <SvgIcon viewBox={'0 0 16 16'} component={Icon} {...props} fill="currentColor" />
export default FSettingsCog
